export default __webpack_public_path__ + "static/media/invalid-name.5d707ef7.svg";